module.exports = {"closeButtonText":"Dichtbij","thumbNailAlt":"Voorbeeld van afbeelding weergeven","next":"Volgende bladzijde","previous":"Vorige bladzijde","addNote":"Voeg een opmerking toe..."}


//////////////////
// WEBPACK FOOTER
// ./translations/nl.json
// module id = 26
// module chunks = 0